<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="text-center">
      <h4>{{ isAdded ? "添加" + roleName : "编辑" + roleName }}</h4>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small" v-loading="loading">
      <el-form ref="model" :rules="rules" :model="model" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input
            @change="checkAllInputs"
            placeholder="请输入姓名"
            v-model="model.name"
            class="input-width"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input
            @change="checkAllInputs"
            placeholder="请输入手机"
            v-model="model.phone"
            class="input-width"
            maxlength="15"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-scs-password
            @change="checkAllInputs"
            ref="el-scs-password"
            placeholder="请输入密码"
            v-model="model.password"
            class="input-width"
          ></el-scs-password>
        </el-form-item>
        <el-form-item label="确认密码" prop="passwordAgain">
          <el-scs-password
            @change="checkAllInputs"
            ref="el-scs-passwordagain"
            placeholder="请输入确认密码"
            v-model="model.passwordAgain"
            class="input-width"
          ></el-scs-password>
        </el-form-item>
        <el-form-item label="使用权限">
          <el-select
            @change="onRoleIdChange"
            v-model="model.roleId"
            placeholder="请选择使用权限"
          >
            <el-option
              v-for="(item, index) in roleTypes"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isAdded" label="在职状态">
          <el-select
            @change="checkAllInputs"
            v-model="model.isActive"
            placeholder="请选择在职状态"
          >
            <el-option key="0" label="在职" :value="true"></el-option>
            <el-option key="1" label="离职" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="`${category}` !== '3'">
          <el-form-item label="学校">
            <el-select
              v-model="model.universityGroupList"
              multiple
              placeholder="请选择学校"
              size="small"
            >
              <el-option
                v-for="item in universityGroups"
                :key="item.IdValue"
                :label="item.NameValue"
                :value="item.GroupNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职业培训">
            <el-select
              v-model="model.trainingCategoryIdList"
              multiple
              placeholder="请选择职业培训业务"
              size="small"
            >
              <el-option
                v-for="item in trainingCategoryList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-else-if="model.roleId === GLOBAL.roleType.saFinancialManager || model.roleId === GLOBAL.roleType.saFinancialAssistant">
          <el-form-item label="负责渠道">
            <el-select
              v-model="model.channelIdList"
              multiple
              placeholder="请选择负责渠道"
              size="small"
            >
              <el-option
                v-for="item in channelList"
                :key="item.Key"
                :label="item.Value"
                :value="item.Key"
              ></el-option>
            </el-select>
        </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="20" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="footer-right" :span="4">
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
            >{{ isAdded ? "确认添加" : "保存更新" }}</el-button
          >
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import elScsPassword from "../common/el-scs-password";
import {
  getUniversityGroups,
  getTrainingCategoryList,
} from "@/service/common.service";
import {
  getChannelItems
} from "@/service/studyAbroad.service";
import { saveEmployee } from "@/service/user.service";

export default {
  props: {
    data: {},
    dialogVisible: false,
    category: {
      //1-行政, 2-财务, 3-真留
      type: [Number, String],
      default: 1,
      validator: (value) => {
        let strValue = `${value}`;
        return ["1", "2", "3"].contains(strValue);
      }
    }
  },
  data() {
    let validatePassCheck = (rule, value, callback) => {
      // if (typeof value === "undefined" || value === "") {
      //   callback(new Error("请输入确认密码"));
      // } else
      if (value !== this.model.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };

    let validatePass = (rule, value, callback) => {
      if (value) {
        let isValid = value.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
        );
        if (!isValid) {
          callback(new Error("密码需为8位长度的大小写字母和数字"));
        } else {
          callback();
        }
      } else {
        callback();
        //callback(new Error("请输入密码"));
      }
    };

    let validatePhone = (rule, value, callback) => {
      let message = "";
      if (value) {
        // if (value.length != 11 && value.length != 10) {
        //   message = "请输入10位或11位数手机号";
        // }
      } else {
        message = "请输入手机号";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      model: {
        name: "",
        phone: "",
        password: "",
        passwordAgain: "",
        roleId: 0,
        isActive: false,
        universityGroupList: [],
        trainingCategoryIdList: [],
        channelIdList: []
      },
      loading: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      submitBtnStatus: {
        status: true,
        stopTime: null,
        resetStatus: function () {
          let self = this;
          clearTimeout(self.stopTime);
          self.stopTime = setTimeout(() => {
            self.status = true;
          }, 1500);
        },
      },
      roleName: "",
      isAdded: false,
      roleTypes: [],
      showError: false,
      errorMessage: "",
      universityGroups: [],
      trainingCategoryList: [],
      channelList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          {
            min: 0,
            max: 20,
            message: "最大长度在为20个字符",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        password: [
          {
            required: false,
            validator: validatePass,
            trigger: "blur",
          },
        ],
        passwordAgain: [
          {
            required: false,
            validator: validatePassCheck,
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    elScsPassword,
  },
  created() {
    let list = [];
    switch (`${this.category}`) {
      case "2":
        this.roleName = "财务";
        list = this.GLOBAL.roleType.getOptionsByType(this.roleName);
        break;
      case "3":
        this.roleName = "真留";
        let type2, exceptKeys;
        if (this.USERMANAGER.isSABusiness) {
          type2 = "业务";
          exceptKeys = ["saBusinessManager"];
        } else if (this.USERMANAGER.isSAFinancial) {
          type2 = "财务";
          exceptKeys = ["saFinancialManager"];
        }
        list = this.GLOBAL.roleType.getOptionsByType(this.roleName, type2, exceptKeys);
        break;
      default:
        this.roleName = "行政";
        list = this.GLOBAL.roleType.getOptionsByKeys([
          "sales",
          "assistant",
          "receptionist",
          "academicDirector",
          "regionCEO",
          "campusPresident",
          "vocationalTrainingManager",
          "internationalSales"
        ]);
        if (this.USERMANAGER.isAdmin || this.USERMANAGER.isPersonnelManagement) {
          list.push(
            this.GLOBAL.roleType.valueOf(this.GLOBAL.roleType.executiveManager),
            this.GLOBAL.roleType.valueOf(this.GLOBAL.roleType.educationalAssistant),
            this.GLOBAL.roleType.valueOf(this.GLOBAL.roleType.platformEditor),
            this.GLOBAL.roleType.valueOf(this.GLOBAL.roleType.personnelManagement)
          );
        }
        break;
    }

    this.roleTypes = list;
    getUniversityGroups(true).then((result) => {
      if (!!result && result.success) {
        this.universityGroups = result.data;
      }
    });
    getTrainingCategoryList(3, false, true).then((result) => {
      if (!!result && result.success) {
        this.trainingCategoryList = result.data;
      }
    });
    getChannelItems().then((result) => {
      this.channelList = !!result && result.success ? this.channelList.concat(result.data) : [];
    });
    this.loadData();
  },
  methods: {
    checkAllInputs(value, onlyCheck) {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate((valid) => {
        if (!valid) {
          isValid = false;
          return;
        }
      });

      if (onlyCheck) return isValid;

      //this.submitBtnClass = isValid ? "primary" : "info";
      //this.submitBtnDisable = !isValid;

      return isValid;
    },
    save() {
      if (this.submitBtnStatus.status) {
        this.submitBtnStatus.status = false;

        let isValid = this.checkAllInputs(null, true);
        if (!isValid) return false;

        this.submitBtnDisable = true;
        this.loading = true;
        let result = saveEmployee(
          this.model.id,
          this.model.roleId,
          this.model.name,
          this.model.phone,
          this.model.password,
          this.model.isActive,
          this.model.universityGroupList,
          this.model.trainingCategoryIdList,
          this.model.channelIdList
        ).then((result) => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.showError = false;
            this.$emit("saveSuccess", this.isAdded, result.data);
            this.close();
          }
          this.submitBtnDisable = false;
          this.loading = true;
        });
      }

      this.submitBtnStatus.resetStatus();
    },
    close() {
      //this.$refs["model"].resetFields();
      this.$emit("closeDialog");
    },
    loadData() {
      this.loading = false;
      if (!!this.$refs["el-scs-password"])
        this.$refs["el-scs-password"].setShowPassword(false);
      if (!!this.$refs["el-scs-passwordagain"]) {
        this.$refs["el-scs-passwordagain"].setShowPassword(false);
      }
      if (!!this.data && !!this.data.Id) {
        this.isAdded = false;
        this.model.id = this.data.Id;
        this.model.roleId = this.data.RoleId;
        this.model.name = this.data.Name;
        this.model.isActive = this.data.IsActive;
        this.model.phone = this.data.Phone;
        //this.submitBtnClass = "primary";
        //this.submitBtnDisable = false;
        this.model.password = "";
        this.model.passwordAgain = "";
        this.model.universityGroupList = this.data.UniversityGroupList;
        this.model.trainingCategoryIdList = this.data.TrainingCategoryIdList;
        this.model.channelIdList = this.data.ChannelIdList;
      } else {
        this.isAdded = true;
        this.model.id = "";
        this.model.roleId = this.roleTypes[0].value;
        this.model.name = "";
        this.model.isActive = true;
        this.model.phone = "";
        this.model.password = "";
        this.model.passwordAgain = "";
        this.model.universityGroupList = [];
        this.model.trainingCategoryIdList = [];
        this.model.channelIdList = [];
        //this.submitBtnClass = "info";
        //this.submitBtnDisable = true;
      }
    },
    onRoleIdChange() {
      this.model.channelIdList = [];

      this.checkAllInputs();
    }
  },
  watch: {
    data: function () {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/receptionist/receptionistEdit.vue